import * as Event from '../tools/Event';
import { hasClass, addClass, removeClass } from '../tools/DOM';
import { MQ } from '../tools/MQ';


export const init = () => {
	const SELECTOR = '.js-toggle';
	const OPENED_CLASS = 'is-opened';
	const ACTIVE_CLASS = 'is-active';
	const TOGGLE_SELECTOR = '[data-toggle]';
	const TOGGLEABLE_ATTR = 'data-toggleable';
	const TOGGLEABLE_SELECTOR = `[${TOGGLEABLE_ATTR}]`;
	const TRANSITION_DURATION = 300;
	let isAnimating = false;
	let isDragging = false;

	const onClick = (event) => {
		event.preventDefault();

		if (isAnimating || isDragging) return;

		const link = event.target.closest(SELECTOR);

		if (hasClass(link, 'footer__title') && MQ('tabletMin')) return;

		const href = link.getAttribute('href');
		let isSimple = false;
		let item;


		if (!!href && href !== '#') {
			item = document.querySelector(href);
			isSimple = true;
		} else {
			item = link.closest(TOGGLE_SELECTOR);
			isAnimating = true;
		}

		const isOpened = hasClass(item, OPENED_CLASS);

		if (isOpened) {
			close(item, isSimple);
			removeClass(link, ACTIVE_CLASS);
		} else {
			open(item, isSimple);
			addClass(link, ACTIVE_CLASS);
		}

		switchLabel(link);
		resetHeight(item.querySelector(TOGGLEABLE_SELECTOR));
	};

	const switchLabel = (link) => {
		const newLabel = link.getAttribute('data-less');
		const labelElement = link.querySelector('.link-more__label');

		if (!newLabel && !labelElement) return;

		const oldLabel = labelElement.innerText;

		labelElement.innerText = newLabel;
		link.setAttribute('data-less', oldLabel);
	};

	const open = (item, isSimple) => {
		if (isSimple) {
			const focus = item.querySelector('[data-focus]');

			addClass(item, OPENED_CLASS);

			if (focus) {
				setTimeout(() => focus.focus(), 300);
			}

			return;
		}

		const more = item.querySelector(TOGGLEABLE_SELECTOR);
		const height = more.scrollHeight;

		addClass(item, OPENED_CLASS);
		more.style.height = `${height}px`;
	};

	const close = (item, isSimple) => {
		if (isSimple) {
			removeClass(item, OPENED_CLASS);
			return;
		}

		const more = item.querySelector(TOGGLEABLE_SELECTOR);
		const height = more.scrollHeight;

		more.style.height = `${height}px`;

		setTimeout(() => {
			removeClass(item, OPENED_CLASS);
			more.style.height = '0px';
		}, 20);
	};

	const resetHeight = (item) => setTimeout(() => {
		if (!item) return;

		item.style.height = '';
		isAnimating = false;
	}, TRANSITION_DURATION);


	Event.on(document, 'touchstart', () => { isDragging = false; }, SELECTOR);
	Event.on(document, 'touchmove', () => { isDragging = true; }, SELECTOR);
	Event.on(document, 'click touchend', onClick, SELECTOR);
};



// WEBPACK FOOTER //
// ./src/js/components/toggle.js